import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { _ } from "@ngx-translate/core";

_('EntityTranslation.NewResource');
_('EntityTranslation.NewActivity');
_('EntityTranslation.UpdateResource');
_('EntityTranslation.UpdateActivity');

@Injectable({
  providedIn: 'root'
})
export class EntityNextStepService {

  constructor(
    private readonly http: HttpClient
  ) { }

  getNextStep(entity: INextLevelQueryCriteriaDTO): Observable<NextLevelQueryResponseLineDTO[]> {
    return this.http.put<NextLevelQueryResponseLineDTO[]>(`${environment.apiUrl}model/entity/next-level`, entity);
  }

}

export interface INextLevelQueryCriteriaDTO {
  activityIndex: number;
  direction: number;
  level: number;
  qty: number;
  qtyUnit: string;
}

export interface NextLevelQueryResponseLineDTO {
  id: number;
  materialIndex: number;
  materialDesc: string;
  level: number;
  qty: number;
  qtyUnit: string;
  selectedActivityIndex: number;
  alternatives: NextLevelQueryResponseAcitvityAltDTO[];
  forcast: number;
}

export interface NextLevelQueryResponseAcitvityAltDTO {
  index: number;
  description: string;
  entyGroupCode: string;
}
